import React, { useEffect, useState } from "react";
import AthleteLayout from "../common/AthleteLayout";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import { Link } from "react-router-dom";
import API_URL from "../../api/API";
import ladyRun from "../../images/ladyRun.png";

export const AthletePurchaseStaticSpeedTemplates = () => {
  const { athlete } = useAthleteAuthContext();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTemplates = async () => {
    try {
      const response = await fetch(API_URL.FRONTEND_SPEED_ALL_PRODUCTS, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${athlete.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();

      // Controller returns: { message, data: [ ... ] }
      if (data && Array.isArray(data.data)) {
        setTemplates(data.data);
      } else {
        setTemplates([]);
      }
    } catch (err) {
      setError(err.message);
      console.error("Error fetching speed products:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return (
    <AthleteLayout>
      <div className="h-full overflow-y-auto bg-white">
        <div className="w-full max-w-2xl mx-auto px-5">
          {/* Back button */}
          <div className="py-5 w-full max-w-96 mx-auto">
            <Link
              to="/athlete/tools"
              className="flex items-center gap-2 text-black text-base hover:opacity-70 transition-all"
            >
              <span className="w-2 h-2 border-[1.5px] border-black border-solid rotate-45 border-t-0 border-r-0"></span>
              Back
            </Link>
          </div>

          <div
            className="tabbing w-full max-w-96 mx-auto"
            id="default-tab-content"
          >
            {/* Tab header */}
            <div className="flex flex-row justify-center text-center mb-2">
              <div className="w-1/2 pr-1.5">
                <p className="text-base pb-2.5 cursor-pointer text-black border-b-2 border-darkYellow">
                  Speed
                </p>
              </div>

              <div className="w-1/2 pl-1.5">
                <Link to="/athlete/purchase/static-strength-templates">
                  <p className="text-base pb-2.5 cursor-pointer text-lightSmock border-b border-smock">
                    Strength
                  </p>
                </Link>
              </div>
            </div>

            {/* Conditional Rendering */}
            {loading && (
              <div className="flex justify-center items-center h-full">
                <p>Loading templates...</p>
              </div>
            )}

            {error && (
              <div className="flex justify-center items-center h-full">
                <p className="text-red-500">Error: {error}</p>
              </div>
            )}

            {!loading && !error && templates.length === 0 && (
              <div className="flex justify-center items-center h-full">
                <p>No templates available at the moment.</p>
              </div>
            )}

            {!loading && !error && templates.length > 0 && (
              <div className="grid grid-cols-2 gap-x-3 gap-y-5 py-3">
                {templates.map((template) => (
                  <Link
                    key={template._id}
                    to={`/athlete/purchase/static-speed-template-detail/${template._id}`}
                    className="block rounded-b-xl hover:shadow-md"
                  >
                    <div className="flex flex-col">
                      <div className="aspect-square rounded-xl overflow-hidden">
                        {template.image ? (
                          <img
                            src={`${API_URL.SERVER_PICTURE_URL}${template.image}`}
                            alt={template.title}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <img
                            src={ladyRun}
                            alt={template.title}
                            className="w-full h-full object-cover"
                          />
                        )}
                      </div>
                      <div className="p-2 xs:p-3 space-y-1">
                        <p className="text-black text-sm leading-tight capitalize line-clamp-2 min-h-[1.3rem]">
                          {template.title}
                        </p>

                        <span className="text-black text-sm xs:text-base font-light">
                          ${template.price || 0}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};
